<template>
  <v-container fluid class="tp-page">
    <template v-if="!addHistorico">
      <!-- Cabeçalho -->
      <div class="tp-page-head">
        <div>
          <h1 class="tp-page-title">Histórico</h1>
          <p class="tp-page-sub">{{ historicos.length }} no total</p>
        </div>
        <div class="tp-head-actions">
          <v-select outlined dense v-model="programaId" :items="programas" item-text="nome" item-value="id"
            label="Selecione o Programa" @input="carregaHistoricos()" color="#00695C" hide-details
            class="tp-search"></v-select>
          <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense
            outlined color="#00695C" class="tp-search"></v-text-field>
          <v-btn color="#00695C" dark depressed rounded class="tp-btn-add" @click="criarNovo">
            <v-icon left>mdi-plus-circle-outline</v-icon>Registrar Entrega
          </v-btn>
        </div>
      </div>

      <!-- Tabela -->
      <v-card class="tp-card" elevation="0">
        <v-data-table :search="search" :headers="headers" :items="historicos" sort-by="dataHoraEntrega">
          <template v-slot:[`item.action`]="{ item }">
            <v-icon small class="mr-3" color="#00695C" @click="editItem(item)">edit</v-icon>
            <v-icon small class="mr-3" color="error" @click="deleteItem(item)"
              v-if="user.tipo == 'ADMIN' || user.tipo == 'GERENTE'">delete</v-icon>
            <v-icon small color="#00253E" @click="seeItem(item)">mdi-eye</v-icon>
          </template>
          <template v-slot:no-data>
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Nenhum registro de entrega
              encontrado</v-alert>
          </template>
          <template slot="no-results">
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Sua pesquisa por "{{ search }}"
              não trouxe resultados</v-alert>
          </template>
          <template v-slot:[`item.dataHoraEntrega`]="{ item }">
            <td>{{ item.dataHoraEntrega }}</td>
          </template>
          <template v-slot:[`item.quantidadeCestas`]="{ item }">
            <td>{{ item.quantidadeCestas }}</td>
          </template>
        </v-data-table>
      </v-card>
    </template>

    <v-card v-else class="tp-card tp-form" elevation="0">
      <v-card-title>
        <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">{{ formTitle }}</span>
        <v-spacer></v-spacer>
        <p style="font-size:13px; color:#00695C; margin:0"> *Busque o membro por CPF ou Nome</p>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row dense v-if="editedIndex === -1">
            <v-col cols="12" sm="12" md="8" lg="8">
              <v-autocomplete v-model="membroSelecionado" :items="beneficiariosDoPrograma" item-text="nome"
                item-value="membroId" label="Selecione o Beneficiário" outlined color="#00695C" dense
                :loading="isLoading" :disabled="isLoading" return-object @change="selecionarMembroAutocomplete" clearable
                :filter="customFilterBeneficiario"
                :no-data-text="isLoading ? 'Carregando beneficiários...' : 'Nenhum beneficiário encontrado para este programa.'">
                <template v-slot:item="data">
                  <template v-if="data.item && data.item.membro">
                    <div>
                      <strong>{{ data.item.membro.nome }}</strong> <span style="font-size:12px; color:#888">(CPF: {{
                        data.item.membro.cpf }}, Célula: {{ nomeCelula(data.item.membro.celulaId) }})</span>
                    </div>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row dense v-if="membroEncontradoMensagem">
            <v-col cols="12">
              <v-alert dense text :type="membroEncontradoSucesso ? 'info' : 'error'">
                {{ membroEncontradoMensagem }}
              </v-alert>
            </v-col>
          </v-row>

          <v-row dense v-if="editedItem.membroId || editedIndex > -1">
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#00695C" dense
                disabled></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-text-field v-model="editedItem.cpf" outlined label="CPF" color="#00695C" dense
                disabled></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-select v-model="editedItem.celulaId" outlined label="Célula" color="#00695C" :items="celulas"
                item-text="nome" item-value="id" dense disabled></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4">
              <v-text-field v-model="editedItem.dataHoraEntrega" label="Data e Hora da Entrega" outlined
                color="#00695C" v-mask="'##/##/#### ##:##:##'" dense required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="4">
              <v-text-field v-model.number="editedItem.quantidadeCestas" label="Quantidade de Cestas" outlined
                color="#00695C" type="number" dense required></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn color="#00695C" text large @click="closeAddEdit">Cancelar</v-btn>
        <v-btn color="#00695C" dark depressed rounded large class="tp-btn-add px-6" @click='saveHistorico'
          :disabled="!editedItem.membroId && editedIndex === -1">Salvar</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialogoDadosHistorico" max-width="1000px" scrollable>
      <v-card class="tp-card" elevation="0">
        <v-card-title>
          <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">DETALHES DO REGISTRO DE ENTREGA</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12" sm="12" md="12" lg="12">
                <p style="margin-bottom: 5px">Informações do Registro</p>
                <v-divider />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#00695C" dense
                  hide-details :readonly="true"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <v-text-field v-model="editedItem.dataNascimento" label="Data de Nascimento" outlined color="#00695C"
                  dense hide-details :readonly="true"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <v-text-field v-model="editedItem.idade" label="Idade" outlined color="#00695C" dense hide-details
                  :readonly="true"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-text-field v-model="editedItem.celulaId" outlined label="Célula" color="#00695C" dense hide-details
                  :readonly="true"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.dataHoraEntrega" label="Data e Hora da Entrega" outlined dense
                  readonly></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.quantidadeCestas" label="Quantidade de Cestas" outlined dense
                  readonly></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="#00695C" text large @click="dialogoDadosHistorico = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import moment from 'moment'
import axios from 'axios'
import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'

export default {
  components: {
    Snackbar,
    Loading,
  },
  directives: { mask },
  data: () => ({
    dialogoDadosHistorico: false,
    programaId: '',
    programaIdAtual: '',
    fullPage: true,
    isLoading: false,
    loading: false,
    search: '',
    addHistorico: false,

    headers: [
      { text: 'Nome', align: 'start', value: 'nome', },
      { text: 'CPF', value: 'cpf' },
      { text: 'Célula', value: 'celula' },
      { text: 'Data e Hora da Entrega', value: 'dataHoraEntrega' },
      { text: 'Qtd. Cestas', value: 'quantidadeCestas' },
      { text: 'Ações', value: 'action', align: 'center', sortable: true },
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      nome: '',
      cpf: '',
      sexo: '',
      dataNascimento: '',
      celulaId: '',
      membroId: null,
      membro: null,
      dataHoraEntrega: '',
      quantidadeCestas: null,
    },
    defaultItem: {
      id: null,
      nome: '',
      cpf: '',
      sexo: '',
      dataNascimento: '',
      celulaId: '',
      membroId: null,
      membro: null,
      dataHoraEntrega: '',
      quantidadeCestas: null,
    },
    programas: [],
    historicos: [],
    celulas: [],
    membroEncontradoMensagem: '',
    membroEncontradoSucesso: false,
    beneficiariosDoPrograma: [],
    membroSelecionado: null,
  }),

  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    user: state => state.userObj,
    companyobj: state => state.companyObj,
    formTitle() {
      return this.editedIndex === -1 ? 'ADICIONAR REGISTRO DE ENTREGA' : 'EDITAR REGISTRO DE ENTREGA'
    }
  }),

  mounted() {
    this.carregaCelulas();
    this.carregaDados();
    this.$watch('programaId', (novo) => {
      if (novo) {
        this.carregaHistoricos();
        this.carregaBeneficiariosDoPrograma();
      }
    });
  },

  methods: {
    async carregaCelulas() {
      await axios.get(baseApiUrl + 'Celulas?filter={"where":{"igrejaId":"' + this.user.igrejaId + '"}, "fields":{"nome": true, "id": true}, "order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.celulas = response.data
          }
        })
    },

    async carregaDados() {
      this.isLoading = true
      let url
      if (this.user.tipo == 'PROGRAMA') {
        url = 'Programas?filter={"where":{"and":[{"igrejaId":"' + this.user.igrejaId + '"},{"tipo":"EM"}]}}'
      } else {
        url = 'Programas?filter={"where":{"and":[{"igrejaId":"' + this.user.igrejaId + '"}]}}'
      }
      await axios.get(baseApiUrl + url + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.programas = response.data.sort(this.compare)
            if (!this.programaId && this.programas.length > 0) {
              this.programaId = this.programas[0].id
            }
            if (this.programaIdAtual)
              this.programaId = this.programaIdAtual
          } else {
            this.isLoading = false
          }
        })
      await this.carregaHistoricos()
      if (this.programaId) {
        await this.carregaBeneficiariosDoPrograma();
      }
    },

    async saveHistorico() {
      this.isLoading = true;
      const vm = this;

      if (!this.editedItem.membroId && this.editedIndex === -1) {
        this.isLoading = false;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Por favor, selecione um beneficiário.", "ATENÇÃO");
        return;
      }

      if (!this.editedItem.dataHoraEntrega || this.editedItem.quantidadeCestas === null) {
        this.isLoading = false;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Por favor, preencha a data/hora e a quantidade de cestas.", "ATENÇÃO");
        return;
      }

      const dataHoraEntregaFormatada = moment(this.editedItem.dataHoraEntrega, 'DD/MM/YYYY HH:mm:ss', true);

      if (!dataHoraEntregaFormatada.isValid()) {
        this.isLoading = false;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Formato de data e hora inválido. Use DD/MM/YYYY HH:mm:ss", "ATENÇÃO");
        return;
      }

      if (this.editedItem.quantidadeCestas <= 0) {
        this.isLoading = false;
        vm.$refs.chamaSnackbar.snack("#EF5350", "A quantidade de cestas deve ser maior que zero.", "ATENÇÃO");
        return;
      }

      const historicoData = {
        programaId: this.programaId,
        igrejaId: this.user.igrejaId,
        dataHoraEntrega: dataHoraEntregaFormatada.toISOString(),
        quantidadeCestas: this.editedItem.quantidadeCestas,
      };

      if (this.editedIndex === -1) {
        historicoData.membroId = this.editedItem.membroId;
        historicoData.nome = this.editedItem.nome;
      } else {
        historicoData.id = this.editedItem.id;
      }

      try {
        if (this.editedIndex > -1) {
          const response = await axios.patch(`${baseApiUrl}Historicos/${historicoData.id}?access_token=${sessionStorage.getItem('accToken')}`, historicoData);
          if (response.data) {
            vm.$refs.chamaSnackbar.snack("#0288D1", "Registro de entrega atualizado com sucesso!", "INFORMAÇÃO");
          }
        } else {
          const response = await axios.post(`${baseApiUrl}Historicos?access_token=${sessionStorage.getItem('accToken')}`, historicoData);
          if (response.data) {
            vm.$refs.chamaSnackbar.snack("#0288D1", "Registro de entrega cadastrado com sucesso!", "INFORMAÇÃO");
          }
        }
        await this.carregaHistoricos();
        this.closeAddEdit();
      } catch (error) {
        this.isLoading = false;
        const errorMessage = error.response && error.response.data && error.response.data.error && error.response.data.error.message
          ? error.response.data.error.message
          : "Erro ao realizar operação, tente novamente.";
        vm.$refs.chamaSnackbar.snack("#EF5350", errorMessage, "ERRO");
      }
    },

    compare(a, b) {
      const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY', true).format()
      const dataC = moment().format()

      let comparison = 0;
      if (dataC >= dataA)
        comparison = 1;
      else if (dataC < dataA)
        comparison = -1;
      return comparison;
    },

    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHour(data_hora) {
      if (!data_hora) return 'N/A';
      return moment(data_hora).format('DD/MM/YYYY HH:mm:ss');
    },

    formatDateBrz(date) {
      if (!date || typeof date !== 'string') return 'N/A';
      if (date.includes('-')) {
        const [year, month, day] = date.split('-');
        if (year && month && day) return `${day}/${month}/${year}`;
      } else if (date.includes('/')) {
        const partes = date.split('/');
        if (partes.length === 3) return date;
      }
      return 'N/A';
    },

    formatDatePadrao(date) {
      if (!date) return null
      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateHora(date) {
      if (!date) return null
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },

    async carregaHistoricos() {
      this.historicos = [];
      this.isLoading = true;

      if (!this.programaId) {
        this.isLoading = false;
        return;
      }

      let filterString = `{"where":{"programaId":"${this.programaId}"}`;
      filterString += `, "order":"dataHoraEntrega DESC", "include":"membro"}`;

      try {
        const response = await axios.get(baseApiUrl + `Historicos?filter=${filterString}&access_token=${sessionStorage.getItem('accToken')}`);
        let historicosProcessados = [];
        for (let i = 0; i < response.data.length; i++) {
          const historicoApi = response.data[i];
          const membro = historicoApi.membro || {};

          const nomeMembro = historicoApi.nome || membro.nome || 'N/A';
          const celulaMembro = membro.celulaId ? this.nomeCelula(membro.celulaId).trim() : 'N/A';

          historicosProcessados.push({
            "nome": nomeMembro,
            "cpf": membro.cpf || 'N/A',
            "sexo": membro.sexo || 'N/A',
            "dataNascimento": membro.dataNascimento ? this.formatDateBrz(membro.dataNascimento) : 'N/A',
            "idade": membro.dataNascimento ? this.calculaIdade(this.formatDateBrz(membro.dataNascimento)) : 'N/A',
            "celula": celulaMembro,
            "id": historicoApi.id,
            "membroId": membro.id,
            "celulaId": membro.celulaId,
            "dataHoraEntrega": historicoApi.dataHoraEntrega ? this.formatDateHour(historicoApi.dataHoraEntrega) : 'N/A',
            "quantidadeCestas": historicoApi.quantidadeCestas,
          });
        }
        this.historicos = historicosProcessados;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.error("Erro ao carregar históricos:", error);
      }
    },

    calculaIdade(dataNasc) {
      if (!dataNasc || dataNasc === 'N/A') return 'N/A';
      const [dia, mes, ano] = dataNasc.split('/').map(Number);
      const dataNascimento = new Date(ano, mes - 1, dia);
      const hoje = new Date();
      let idade = hoje.getFullYear() - dataNascimento.getFullYear();
      const m = hoje.getMonth() - dataNascimento.getMonth();
      if (m < 0 || (m === 0 && hoje.getDate() < dataNascimento.getDate())) {
        idade--;
      }
      return idade;
    },

    nomeCelula(celulaId) {
      const celulaEncontrada = this.celulas.find(celula => celula.id === celulaId);
      return celulaEncontrada ? celulaEncontrada.nome : 'N/A';
    },

    async editItem(item) {
      this.isLoading = true;
      this.editedIndex = this.historicos.indexOf(item);

      try {
        const response = await axios.get(`${baseApiUrl}Historicos/${item.id}?filter={"include":"membro"}&access_token=${sessionStorage.getItem('accToken')}`);
        if (response.data) {
          const historicoCompleto = response.data;
          const membro = historicoCompleto.membro || {};

          this.editedItem = {
            id: historicoCompleto.id,
            nome: membro.nome || historicoCompleto.nome || '',
            cpf: membro.cpf || '',
            sexo: membro.sexo || '',
            dataNascimento: membro.dataNascimento ? this.formatDateBrz(membro.dataNascimento) : '',
            celulaId: membro.celulaId || '',
            membroId: membro.id,
            membro: membro,
            dataHoraEntrega: historicoCompleto.dataHoraEntrega ? this.formatDateHour(historicoCompleto.dataHoraEntrega) : '',
            quantidadeCestas: historicoCompleto.quantidadeCestas,
          };
          this.addHistorico = true;
          this.isLoading = false;
          this.membroSelecionado = null;
          this.membroEncontradoMensagem = '';
          this.membroEncontradoSucesso = false;
        }
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Problema encontrado ao editar registro de entrega", "DESCULPE");
      }
    },

    deleteItem(item) {
      var r = confirm('Deseja realmente excluir este registro de entrega para: ' + item.nome + '?')
      if (r == true) {
        this.isLoading = true
        axios.delete(`${baseApiUrl}Historicos/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaHistoricos()
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
      }
    },

    closeAddEdit() {
      this.addHistorico = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.membroSelecionado = null;
        this.beneficiariosDoPrograma = [];
        this.membroEncontradoMensagem = '';
        this.membroEncontradoSucesso = false;
      }, 300);
    },

    transformaData(data, formato) {
      let date = moment(data).format(formato);
      return date
    },

    async seeItem(item) {
      this.isLoading = true
      try {
        const response = await axios.get(`${baseApiUrl}Historicos/${item.id}?filter={"include":"membro"}&access_token=${sessionStorage.getItem('accToken')}`);
        if (response.data) {
          const historicoCompleto = response.data;
          const membro = historicoCompleto.membro || {};

          const nomeMembro = membro.nome || historicoCompleto.nome || 'N/A';
          const sexoMembro = membro.sexo || 'N/A';
          const dataNascimentoMembro = membro.dataNascimento ? this.formatDateBrz(membro.dataNascimento) : 'N/A';
          const celulaMembro = membro.celulaId ? this.nomeCelula(membro.celulaId).trim() : 'N/A';
          const idadeMembro = membro.dataNascimento ? this.calculaIdade(this.formatDateBrz(membro.dataNascimento)) + ' anos' : 'N/A';

          let dados = {
            "nome": nomeMembro,
            "cpf": membro.cpf || 'N/A',
            "sexo": sexoMembro,
            "dataNascimento": dataNascimentoMembro,
            "celula": celulaMembro,
            "idade": idadeMembro,
            "id": historicoCompleto.id,
            "dataHoraEntrega": historicoCompleto.dataHoraEntrega ? this.formatDateHour(historicoCompleto.dataHoraEntrega) : 'N/A',
            "quantidadeCestas": historicoCompleto.quantidadeCestas,
          }
          this.editedItem = Object.assign({}, dados)
          this.dialogoDadosHistorico = true
          this.isLoading = false
        }
      } catch (error) {
        this.isLoading = false
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Problema encontrado ao visualizar registro de entrega", "DESCULPE")
      }
    },

    criarNovo() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      // Set dataHoraEntrega to the current date and time
      this.editedItem.dataHoraEntrega = moment().format('DD/MM/YYYY HH:mm:ss'); // Automatically fill with current date/time

      this.membroEncontradoMensagem = '';
      this.membroEncontradoSucesso = false;
      this.addHistorico = true;
      this.membroSelecionado = null;
      if (this.programaId) {
        this.carregaBeneficiariosDoPrograma();
      } else {
        const vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Por favor, selecione um programa antes de registrar uma entrega.", "ATENÇÃO");
        this.addHistorico = false;
      }
    },

    async carregaBeneficiariosDoPrograma() {
      this.isLoading = true;
      this.beneficiariosDoPrograma = [];

      if (!this.programaId) {
        this.isLoading = false;
        return;
      }

      try {
        const filter = {
          where: {
            igrejaId: this.user.igrejaId,
            programaId: this.programaId
          },
          order: 'nome ASC',
          include: 'membro'
        };
        const response = await axios.get(`${baseApiUrl}Beneficiarios?filter=${encodeURIComponent(JSON.stringify(filter))}&access_token=${sessionStorage.getItem('accToken')}`);
        this.beneficiariosDoPrograma = response.data.map(beneficiario => {
          return {
            ...beneficiario,
            nome: beneficiario.membro ? beneficiario.membro.nome : 'N/A',
            cpf: beneficiario.membro ? beneficiario.membro.cpf : 'N/A',
          };
        }) || [];
      } catch (error) {
        this.beneficiariosDoPrograma = [];
        this.membroEncontradoMensagem = 'Erro ao carregar lista de beneficiários do programa.';
        this.membroEncontradoSucesso = false;
      } finally {
        this.isLoading = false;
      }
    },

    selecionarMembroAutocomplete(beneficiario) {
      if (!beneficiario || !beneficiario.membro) {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.membroEncontradoMensagem = '';
        this.membroEncontradoSucesso = false;
        return;
      }
      const membro = beneficiario.membro;
      this.editedItem.nome = membro.nome;
      this.editedItem.cpf = membro.cpf;
      this.editedItem.sexo = membro.sexo;
      this.editedItem.dataNascimento = membro.dataNascimento ? this.formatDateBrz(membro.dataNascimento) : 'N/A';
      this.editedItem.celulaId = membro.celulaId;
      this.editedItem.membroId = membro.id;
      this.editedItem.membro = membro;
      this.membroEncontradoMensagem = `Beneficiário selecionado: ${membro.nome} (CPF: ${membro.cpf}).`;
      this.membroEncontradoSucesso = true;
    },

    customFilterBeneficiario(item, queryText, itemText) {
      const text = (item.membro.nome + ' ' + (item.membro.cpf || '')).toLowerCase();
      const searchText = queryText.toLowerCase();
      return text.includes(searchText);
    },
  },
}
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 150px;
  font-size: 7px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>